import script from "./NewPaywall.vue?vue&type=script&setup=true&lang=js"
export * from "./NewPaywall.vue?vue&type=script&setup=true&lang=js"

import "./NewPaywall.vue?vue&type=style&index=0&id=3085e397&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3085e397"]])

export default __exports__